<template>
  <div class="contact">
    <div class="contanct_content">
      <van-image :src="require('@/assets/img/contact.jpg')"  class="icon" mode=""/>
    </div>
    <BackButton @back="goBack" :boxLeft=5 :boxTop=50><van-image :src="require('@/assets/img/back_img.png')" width="3rem" height="3rem"></van-image></BackButton>
  </div>
</template>

<script>


export default {
  name: "HomePage",
  data() {
    return {
      navList: [], //导航
      proList: [], //商品
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
  },
};
</script>

<style lang="less" scoped>
// 主题 padding
.contact {
  width: 100%;
  height: 100vh;
  background: url(@/assets/img/contact_bg.png) no-repeat left center;
  background-size: 100% 100%;
  overflow: hidden;
}
.contanct_content {
  background: url(@/assets/img/contact_content_bg.png) no-repeat left center;
  background-size: 100% 100%;
  height: 66%;
  width: 95%;
  margin: 0 auto;
  margin-top: 29%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16% 9%;
}
</style>